"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightIsOnlineCheckInEnabledEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CheckBox_1 = require("../../../CheckBox");
const FlightIsOnlineCheckInEnabledEditor = (props) => {
    const { field } = props;
    const fieldProps = {
        name: 'isOnlineCheckInEnabled',
        modificators: field.modifiers,
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit:OnlineCheckIn', defaultMessage: 'Enabled online check-in' })),
        error: field.error,
        checked: field.input,
        onChange: field.onEvent,
    };
    return (react_1.default.createElement(CheckBox_1.CheckBox, { ...fieldProps }));
};
exports.FlightIsOnlineCheckInEnabledEditor = FlightIsOnlineCheckInEnabledEditor;
//# sourceMappingURL=FlightIsOnlineCheckInEnabledEditor.js.map